// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","900":"component---src-pages-woodworking-tsx","951":"component---src-pages-webdev-tsx"}[chunkId] + "-" + {"218":"28fb40adbeb70a03f07d","691":"0b8189d577006d9fd67a","900":"920424c9df505d047a21","951":"aad9b75f395fb9dfc6f6"}[chunkId] + ".js";
};